import React from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'

import { Boutton } from '@piconetworks/ui'
import ContentSection from 'components/ContentSection'
import PassesList from './PassesList'
import ProductsModule from 'modules/products'
import Router from 'next/router'

import styles from '../Products.module.scss'

import addTestId from 'utils/lib/addTestId'
import { PASS_TYPE } from 'utils/constants/productEdit'
import { useFeatureManager, constants } from 'features/FeatureManager'
import { usePlatformAccessPaywall } from 'features/platformAccess'

const Passes = () => {
    const data = useSelector(ProductsModule.selectors.getPasses)
    const loading = useSelector(ProductsModule.selectors.getProductsLoading)

    const { hasFeature } = useFeatureManager()
    const { openPlatformAccessPaywall, Paywall } =  usePlatformAccessPaywall()
    // should be passes but i am too lazy to add a feature for something going away soon
    const hasPasses = hasFeature(constants.PRODUCT_SUBSCRIPTIONS_FEATURE)

    return (
        <>
            <Paywall />
            <ContentSection.Child className={styles.child}>
                <section className={styles.productsHeader}>
                    <ContentSection.Header>Passes</ContentSection.Header>
                    <Boutton
                        icon={<span className={cx('icon-icon_add', styles.icon)} />}
                        variant="secondary"
                        onClick={() => hasPasses ? Router.push('/products/edit/[type]/[id]', `/products/edit/${PASS_TYPE}/new`, { shallow: true }) : openPlatformAccessPaywall(constants.PRODUCT_SUBSCRIPTIONS_FEATURE)}
                        className={styles.newButton}
                        data-testid={addTestId('button-passes-new')}
                    >
                        New pass
                    </Boutton>
                </section>
            </ContentSection.Child>
            <ContentSection.Child className={styles.child}>
                <PassesList items={data} loading={loading} />
            </ContentSection.Child>
        </>
    )
}

export default Passes
